<div style="margin-top: 20px; margin-left: 20px;">
	<form [formGroup]="settingsForm">
		<legend style="font-weight:bold">Slack Settings</legend>
		<div class="mb-3 row">
			<span class="col-lg-2">Webhook URLs:</span>
			<div class="col-lg-3">
				<textarea [formControl]="slackWebhooks" rows="5" cols="100" placeholder="Paste your URLs here"></textarea>
			</div>
		</div>
	</form>
</div>
